const niveles = [
    {
        cod: 'P',
        des:'PRIMARIA',
    },
   
    {
        cod: 'S',
        des:'SECUNDARIA',
    },
]

const grados_primaria = [
     {
        cod: "1",
        des: "Primer grado",
    },
    {
        cod: "2",
        des: "Segundo grado",
    },
    {
        cod: "3",
        des: "Tercer grado",
    },
    {
        cod: "4",
        des: "Cuarto grado",
    },
    {
        cod: "5",
        des: "Quinto grado",
    },
    {
        cod: "6",
        des: "Sexto grado",
    },
]

const grados_secundaria = [
    {
        cod: "1",
        des: "Primer grado",
    },
    {
        cod: "2",
        des: "Segundo grado",
    },
    {
        cod: "3",
        des: "Tercer grado",
    },
    {
        cod: "4",
        des: "Cuarto grado",
    },
    {
        cod: "5",
        des: "Quinto grado",
    },
]
/* const grados_primaria = [
    {
        cod: "1",
        des: "1ro",
    },
    {
        cod: "2",
        des: "2do",
    },
    {
        cod: "3",
        des: "3ro",
    },
    {
        cod: "4",
        des: "4to",
    },
    {
        cod: "5",
        des: "5to",
    },
    {
        cod: "6",
        des: "6to",
    },
] */

// const grados_secundaria = [
//     {
//         cod: "1",
//         des: "1ro",
//     },
//     {
//         cod: "2",
//         des: "2do",
//     },
//     {
//         cod: "3",
//         des: "3ro",
//     },
//     {
//         cod: "4",
//         des: "4to",
//     },
//     {
//         cod: "5",
//         des: "5to",
//     },
// ]

const generos = [
    {
        cod: 'F',
        des:'FEMENINO',
    },
    {
        cod: 'M',
        des:'MASCULINO',
    },
]

// const secciones = [
//     {
//         cod: "1",
//         des: "ÚNICA",
//     },
//     {
//         cod: "A",
//         des: "A",
//     },
//     {
//         cod: "B",
//         des: "B",
//     },
//     {
//         cod: "C",
//         des: "C",
//     },
//     {
//         cod: "D",
//         des: "D",
//     },
//     {
//         cod: "E",
//         des: "E",
//     },
//     {
//         cod: "F",
//         des: "F",
//     },
//     {
//         cod: "G",
//         des: "G",
//     },
//     {
//         cod: "H",
//         des: "H",
//     },
//     {
//         cod: "I",
//         des: "I",
//     },
//     {
//         cod: "J",
//         des: "J",
//     },
//     {
//         cod: "K",
//         des: "K",
//     },
//     {
//         cod: "L",
//         des: "L",
//     },
//     {
//         cod: "M",
//         des: "M",
//     },
//     {
//         cod: "N",
//         des: "N",
//     },
//     {
//         cod: "O",
//         des: "O",
//     },
//     {
//         cod: "P",
//         des: "P",
//     },
//     {
//         cod: "Q",
//         des: "Q",
//     },
//     {
//         cod: "R",
//         des: "R",
//     },
//     {
//         cod: "S",
//         des: "S",
//     },
//     {
//         cod: "T",
//         des: "T",
//     },
//     {
//         cod: "U",
//         des: "U",
//     },
//     {
//         cod: "W",
//         des: "W",
//     },
//     {
//         cod: "X",
//         des: "X",
//     },
//     {
//         cod: "Y",
//         des: "Y",
//     },
//     {
//         cod: "Z",
//         des: "Z",
//     },
// ]
const secciones = [
    {
        cod: "1",
        des: "ÚNICA",
    },
    {
        cod: "A",
        des: "Sección.A",
    },
    {
        cod: "B",
        des: "Sección.B",
    },
    {
        cod: "C",
        des: "Sección.C",
    },
    {
        cod: "D",
        des: "Sección.D",
    },
    {
        cod: "E",
        des: "Sección.E",
    },
    {
        cod: "F",
        des: "Sección.F",
    },
    {
        cod: "G",
        des: "Sección.G",
    },
    {
        cod: "H",
        des: "Sección.H",
    },
    {
        cod: "I",
        des: "Sección.I",
    },
    {
        cod: "J",
        des: "Sección.J",
    },
    {
        cod: "K",
        des: "Sección.K",
    },
    {
        cod: "L",
        des: "Sección.L",
    },
    {
        cod: "LL",
        des: "Sección.LL",
    },
    {
        cod: "M",
        des: "Sección.M",
    },
    {
        cod: "N",
        des: "Sección.N",
    },
    {
        cod: "O",
        des: "Sección.O",
    },
    {
        cod: "P",
        des: "Sección.P",
    },
    {
        cod: "Q",
        des: "Sección.Q",
    },
    {
        cod: "R",
        des: "Sección.R",
    },
    {
        cod: "RR",
        des: "Sección.RR",
    },
    {
        cod: "S",
        des: "Sección.S",
    },
    {
        cod: "T",
        des: "Sección.T",
    },
    {
        cod: "U",
        des: "Sección.U",
    },
    {
        cod: "V",
        des: "Sección.V",
    },
    {
        cod: "W",
        des: "Sección.W",
    },
    {
        cod: "X",
        des: "Sección.X",
    },
    {
        cod: "Y",
        des: "Sección.Y",
    },
    {
        cod: "Z",
        des: "Sección.Z",
    },
    {
        cod: "A1",
        des: "Sección.A1",
    },
    {
        cod: "B1",
        des: "Sección.B1",
    },
]

export {
    niveles,
    grados_primaria,
    grados_secundaria,
    secciones,
    generos,
}